import React from 'react';
import { Rentals } from 'Components/widgets/rentals/Rentals';
import type { ServicesContextType } from 'Context/ServicesContext';
import { ServicesContext } from 'Context/ServicesContext';
type Props = PropsWithPageTracking<{
  contextValue: ServicesContextType;
  rentals: RentalsTree;
}>;
export const RentalsBooking = ({ contextValue, rentals, ...rest }: Props) => (
  <ServicesContext.Provider value={contextValue}>
    <Rentals {...rest} rentalsTree={rentals} />
  </ServicesContext.Provider>
);
